"use client";

import { useCallback, useRef } from "react";

export type LegacyAction = "left" | "right" | "softDrop" | "cw" | "ccw";

type TouchControlsProps = {
  disabled?: boolean;
  onInput: (action: LegacyAction, held: boolean) => void;
  side: "left" | "right";
};

type ControlButton = {
  action: LegacyAction;
  glyph: string;
  label: string;
};

const buttons: ControlButton[] = [
  { action: "ccw", glyph: "↺", label: "左回転" },
  { action: "left", glyph: "◀", label: "左移動" },
  { action: "softDrop", glyph: "▼", label: "ソフト落下" },
  { action: "right", glyph: "▶", label: "右移動" },
  { action: "cw", glyph: "↻", label: "右回転" },
];

export function TouchControls({ disabled = false, onInput, side }: TouchControlsProps) {
  const pressed = useRef(new Set<number>());

  const release = useCallback(
    (pointerId: number, action: LegacyAction) => {
      if (!pressed.current.delete(pointerId)) return;
      onInput(action, false);
    },
    [onInput],
  );

  return (
    <div aria-label="ゲーム操作" className={`touch-controls controls-${side}`}>
      {buttons.map(({ action, glyph, label }) => (
        <button
          aria-label={label}
          className={`control-button control-${action}`}
          disabled={disabled}
          key={action}
          onContextMenu={(event) => event.preventDefault()}
          onPointerCancel={(event) => release(event.pointerId, action)}
          onPointerDown={(event) => {
            event.preventDefault();
            event.currentTarget.setPointerCapture(event.pointerId);
            pressed.current.add(event.pointerId);
            navigator.vibrate?.(6);
            onInput(action, true);
          }}
          onPointerUp={(event) => release(event.pointerId, action)}
          type="button"
        >
          <span aria-hidden="true">{glyph}</span>
          <small>{label}</small>
        </button>
      ))}
    </div>
  );
}
